/* eslint-disable @typescript-eslint/ban-ts-comment */

/* eslint-disable @typescript-eslint/explicit-function-return-type */
// @ts-nocheck
import { env } from '../env'

if (env.VITE_NODE_ENV === 'production') {
  ;(function (h, o, u, n, d): void {
    h = h[d] = h[d] || {
      q: [],
      onReady: function (c) {
        h.q.push(c)
      },
    }
    d = o.createElement(u)
    d.async = 1
    d.src = n
    n = o.getElementsByTagName(u)[0]
    n.parentNode.insertBefore(d, n)
  })(
    window,
    document,
    'script',
    'https://www.datadoghq-browser-agent.com/datadog-rum.js',
    'DD_RUM',
  )

  DD_RUM.onReady(function () {
    DD_RUM.init({
      clientToken: 'pub87d058f9ca90f98992629cb4c470eca5',
      applicationId: '2b26d0d8-6f30-4cd8-9965-07b8f2695f0c',
      site: 'datadoghq.com',
      service: 'Publish',
      version: '<%=  %>',
      sampleRate: 2,
      trackInteractions: true,
    })
  })
}
